// extracted by mini-css-extract-plugin
export default {"loginCard":"login-page_loginCard__YIeMR","logoWrap":"login-page_logoWrap__2lSp+","logo":"login-page_logo__4QMNe","loginFooter":"login-page_loginFooter__OJA-g"};